import React from 'react';
import './career.css';

const roles = [
  {
    title: 'Frontend Developer',
    description:
      'Build responsive, user-friendly interfaces using modern JavaScript frameworks and design systems while collaborating closely with product and design teams.',
  },
  {
    title: 'Business Development Executive',
    description:
      'Identify opportunities, nurture client relationships, and support commercial growth across our technology and industrial service offerings.',
  },
  {
    title: 'Project Coordinator',
    description:
      'Coordinate internal teams, track milestones, and ensure efficient delivery across multiple service lines and client engagements.',
  },
];

function CareerPage() {
  return (
    <main className='page-shell career-page'>
      <section className='page-hero'>
        <div className='page-copy'>
          <span className='eyebrow'>Careers</span>
          <h1>Join a team building real-world impact.</h1>
          <p>
            We are looking for driven professionals who are passionate about digital transformation,
            execution, and helping businesses grow with purpose.
          </p>
        </div>
      </section>

      <section className='career-list'>
        {roles.map((role) => (
          <article key={role.title} className='career-card'>
            <h2>{role.title}</h2>
            <p>{role.description}</p>
          </article>
        ))}
      </section>

      <section className='career-cta'>
        <h2>Apply today</h2>
        <p>Send your CV and cover letter to:</p>
        <a href='mailto:careers@viewjot.com'>careers@viewjot.com</a>
      </section>
    </main>
  );
}

export default CareerPage;
